import React, { useState, useEffect, useMemo } from 'react'
import { connect, useSelector } from 'react-redux'
import { Button, Layout } from 'antd'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import Logo from './Logo'
import NavNotification from './NavNotification'
import NavProfile from './NavProfile'
import NavLanguage from './NavLanguage'
import NavPanel from './NavPanel'
import NavSearch from './NavSearch'
import SearchInput from './NavSearch/SearchInput.js'
import { toggleCollapsedNav, onMobileNavToggle } from 'store/slices/themeSlice'
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from 'constants/ThemeConstant'
import utils from 'utils'
import { useRefresh } from 'layouts/RefreshContext'

const { Header } = Layout

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props
  const [searchActive, setSearchActive] = useState(false)
  const { triggerRefresh } = useRefresh()
  const { adminSettings } = useSelector((state) => state.auth)

  const onSearchActive = () => {
    setSearchActive(true)
  }

  const onSearchClose = () => {
    setSearchActive(false)
  }

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const isDarkTheme = currentTheme === 'dark'
  const resolvedHeaderNavColor =
    adminSettings?.adminLogoBackgroundColor || headerNavColor
  const headerBgFallback = isDarkTheme ? '#283142' : '#ffffff'

  const navMode = useMemo(() => {
    if (!resolvedHeaderNavColor) {
      return utils.getColorContrast(isDarkTheme ? '#000000' : '#ffffff')
    }
    return utils.getColorContrast(resolvedHeaderNavColor)
  }, [isDarkTheme, resolvedHeaderNavColor])
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return '0px'
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }

  useEffect(() => {
    if (!isMobile) {
      onSearchClose()
    }
  })

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{
        backgroundColor: resolvedHeaderNavColor || headerBgFallback,
      }}
    >
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal m-0">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child cursor-pointer"
                  onClick={() => {
                    onToggle()
                  }}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
              {isMobile ? (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  onClick={() => {
                    onSearchActive()
                  }}
                >
                  <SearchOutlined />
                </li>
              ) : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  style={{ cursor: 'auto' }}
                >
                  <SearchInput mode={navMode} isMobile={isMobile} />
                </li>
              )}
            </ul>
          </div>
          <div className="nav-right row-flex">
            {adminSettings?.customerPortalUrl && (
              <Button
                className="navbar-redirect"
                onClick={() =>
                  window.open(adminSettings.customerPortalUrl, '_blank')
                }
                style={{
                  backgroundColor: adminSettings.primaryColor,
                  color: '#fff',
                  border: `1px solid ${adminSettings.primaryColor}`,
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#fff'
                  e.currentTarget.style.color = adminSettings.primaryColor
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    adminSettings.primaryColor
                  e.currentTarget.style.color = '#fff'
                }}
              >
                Visit Site
              </Button>
            )}
            <Button
              className="navbar-refresh"
              onClick={() => triggerRefresh()}
            >
              Refresh
            </Button>
            {/* <NavNotification /> */}
            {/* <NavLanguage mode={navMode} /> */}
            <NavProfile />
            {/* <NavPanel direction={direction} mode={navMode} /> */}
          </div>
          <NavSearch
            active={searchActive}
            close={onSearchClose}
            mode={navMode}
            resolvedHeaderNavColor={resolvedHeaderNavColor}
          />
        </div>
      </div>
    </Header>
  )
}

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  }
}

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav)
